"use client";

import { useRef, useState } from "react";
import { Button, type ButtonProps } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { MediaPreviewModal } from "./components/MediaPreviewModal";

interface UploadProps extends ButtonProps {
  buttonText?: string;
}

export default function Upload({
  buttonText = "Create",
  mt = "lg",
  ...buttonProps
}: UploadProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [opened, { open, close }] = useDisclosure(false);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      open();
      // Reset input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  const handleClose = () => {
    close();
    setSelectedFile(null);
  };

  return (
    <>
      <Button
        mt={mt}
        leftSection={<IconPlus size={16} />}
        onClick={handleButtonClick}
        {...buttonProps}
      >
        {buttonText}
      </Button>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="video/*"
        onChange={handleFileChange}
      />

      <MediaPreviewModal
        opened={opened}
        onClose={handleClose}
        file={selectedFile}
      />
    </>
  );
}
